import { FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";

export const ActionsTools: FC<{
    repost?: ReactNode,
    bookmark?: ReactNode,
    remove?: ReactNode,
    select?: ReactNode,
    more?: ReactNode,
    status?: ReactNode,
    badge?: ReactNode,
    actionsVisible: Record<string, boolean | undefined>
    isTeamSubscription?: boolean,
}> = ({
    repost,
    bookmark,
    remove,
    select,
    more,
    status,
    badge,
    actionsVisible,
    isTeamSubscription
}) => {
    const { 
        showStatus,
        showBadge,
        showMore,
        showBookmark,
        showRemove,
        showRepost,
        showSelect,
        showBannedStatus,
        loading 
    } = actionsVisible;

    if (loading) return null;

    const leftSide = useMemo(() => {
        if (!showBadge && !showStatus && !showMore) {
            return <div />
        }
        return (
            <>
                {showBadge && badge}
                {showMore && more}
                {showStatus && !showBannedStatus && status}
                {showSelect && select}
            </>
        )
    } ,[showBadge, showStatus, showMore, showSelect, select,badge, status, more])

    const rightSide = useMemo(() => {
        if (!showRepost && !showBookmark && !showRemove && !showSelect) {
            return <div />
        }
        return (
            <>
                {showBannedStatus && status}
                {showRepost && repost}
                {showBookmark && bookmark}
                {showRemove && remove}
            </>
        )
    } ,[showRepost, showBookmark, showRemove, repost, bookmark, remove])

    return (
        <FlexBox 
            width={'100%'} 
            className={`meta-card-actions`} 
            direction="row" 
            justify={isTeamSubscription ? "flex-end" : "space-between"}
        >
            <FlexBox gx={8}>
                {leftSide}
            </FlexBox>
            <FlexBox gx={8}>
                {rightSide}
            </FlexBox>
        </FlexBox>
    )
}import { FlexBox } from "@brg/ui";
import { FC, ReactNode, useMemo } from "react";

export const ActionsTools: FC<{
    repost?: ReactNode,
    bookmark?: ReactNode,
    remove?: ReactNode,
    select?: ReactNode,
    more?: ReactNode,
    status?: ReactNode,
    badge?: ReactNode,
    actionsVisible: Record<string, boolean | undefined>
    isTeamSubscription?: boolean,
}> = ({
    repost,
    bookmark,
    remove,
    select,
    more,
    status,
    badge,
    actionsVisible,
    isTeamSubscription
}) => {
    const { 
        showStatus,
        showBadge,
        showMore,
        showBookmark,
        showRemove,
        showRepost,
        showSelect,
        showBannedStatus,
        loading 
    } = actionsVisible;

    if (loading) return null;

    const leftSide = useMemo(() => {
        if (!showBadge && !showStatus && !showMore) {
            return <div />
        }
        return (
            <>
                {showBadge && badge}
                {showMore && more}
                {showStatus && !showBannedStatus && status}
                {showSelect && select}
            </>
        )
    } ,[showBadge, showStatus, showMore, showSelect, select,badge, status, more])

    const rightSide = useMemo(() => {
        if (!showRepost && !showBookmark && !showRemove && !showSelect) {
            return <div />
        }
        return (
            <>
                {showBannedStatus && status}
                {showRepost && repost}
                {showBookmark && bookmark}
                {showRemove && remove}
            </>
        )
    } ,[showRepost, showBookmark, showRemove, repost, bookmark, remove])

    return (
        <FlexBox 
            width={'100%'} 
            className={`meta-card-actions`} 
            direction="row" 
            justify={isTeamSubscription ? "flex-end" : "space-between"}
        >
            <FlexBox gx={8}>
                {leftSide}
            </FlexBox>
            <FlexBox gx={8}>
                {rightSide}
            </FlexBox>
        </FlexBox>
    )
}